import React, { useCallback, useState } from 'react';
import axios, { AxiosError } from 'axios';

async function getConnectUrlForSite(url: string): Promise<string> {
  const config = {
    method: 'get',
    url: `/quipli-service/v1/qbo/getConnectUrlForSite`,
    params: {
      url,
    },
  };
  const result = await axios(config);
  return result.data.data.connectUrl;
}

export const Launch = () => {
  const [url, setUrl] = useState<string>('');
  const [error, setError] = useState<string>();
  const [isWorking, setIsWorking] = useState<boolean>(false);

  const getConnectUrl = useCallback(async () => {
    setIsWorking(true);
    try {
      if (url) {
        const redirectUrl = await getConnectUrlForSite(url);
        window.location.href = redirectUrl;
      } else {
        setError('Please type the URL for your Quipli website!');
      }
    } catch (e) {
      if (e instanceof AxiosError && e.response && e.response.status === 404 && e.response.data.error) {
        setError(e.response.data.error);
      }
    }
    setIsWorking(false);
  }, [url]);

  return (
    <div className="flex flex-column items-center">
      <div className="text-white flex flex-column items-center md:max-w-[70%] text-center gap-4">
        <h1 className="text-6xl font-['Sharp Grotesk'] font-medium m-0 mt-[4rem] md:mt-[8rem]">
          Connect Your QuickBooks Account
        </h1>
        <form
          className="min-w-[50%]"
          onSubmit={(e) => {
            e.preventDefault();
            getConnectUrl();
          }}
        >
          <label htmlFor="url" className="max-w-[40rem] leading-6 font-light m-0">
            Enter the URL of your Quipli Hosted Website
          </label>
          <div className="flex gap-2 text-[1.1rem] w-full">
            <input name="url" className="grow" type="text" value={url} onChange={(e) => setUrl(e.target.value)} />
            <button
              type="submit"
              className="putton button-yellow font-bold px-[1.5rem] py-[.5rem]"
              disabled={isWorking}
            >
              Submit
            </button>
          </div>
        </form>
        {error && <span className="text-[var(--error-400)]">{error}</span>}
      </div>
      <picture className="m-4 md:m-16">
        <source
          media="(min-width: 768px)"
          srcSet="https://quipli.com/wp-content/themes/quipli-v2/assets/img/home/quipli-rental.webp"
        />
        <source
          media="(min-width: 768px)"
          srcSet="https://quipli.com/wp-content/themes/quipli-v2/assets/img/home/quipli-rental.png"
        />
        <source srcSet="https://quipli.com/wp-content/themes/quipli-v2/assets/img/home/quipli-rental-mob.webp" />
        <source srcSet="https://quipli.com/wp-content/themes/quipli-v2/assets/img/home/quipli-rental-mob.png" />
        <img
          className="max-w-full h-[auto]"
          src="https://quipli.com/wp-content/themes/quipli-v2/assets/img/home/quipli-rental.png"
          alt="Rental Software"
          decoding="async"
          width="1691"
          height="1063"
        />
      </picture>
    </div>
  );
};
